import { merge as _merge } from 'lodash'
import zh_cn from 'core/translations/zh_simplified'

export default _merge(zh_cn, {})
